<template lang="pug">
	.projects-global-search#global-search(v-if="showed" @click="handleClick($event)")
		.card
			.card-body
				.results
					i.fa.fa-spinner.fa-spin(v-if="errorMessage && errorMessage === 'fetching'" :style="{'align-self': 'center', 'margin': 'auto', 'font-size': '60px'}")
					span.error-message(v-else-if="errorMessage && errorMessage.length") {{errorMessage}}
					.result(v-else v-for="project in projects" @click="openProject(project)")
						.left-part
							span {{project.id}}
						.right-part
							span {{Metadata.Templates[project.template_id] ? Metadata.Templates[project.template_id].title : ''}}
							span(:style="{'font-weight': 'bold'}") {{project.title}}
</template>

<script>

import Screen 				from '../../mixins/screen';

import { Project } 			from '@/services/Project';
import { Settings } 		from '@/services/Settings';
import { Metadata}			from "@/services/Metadata";

export default {
	name: "ProjectsGlobalSearch",
	mixins: [Screen],
	props: ['parent', 'searchValue'],
	screen: {
		updateOn: [],
		events: {
			'Global Search Results': function(results) {
				this.projects = results;
				if (results && results.length) this.errorMessage = '';
				else this.errorMessage = 'No results found';
			},
			'Pseudo Modal Process Hide': function (names) {
			}
		}
	},
	watch: {
		searchValue() {
			this.search();
		}
	},
	data() {

		this.Project = Project;
		this.Settings = Settings;
		this.Metadata = Metadata;

		this.showed = false;

		return {
			title: '',
			projects: [],
			errorMessage: '',
			showed: false
		}
	},
	mounted() {

		this.parentNode = document.querySelector(this.parent);

		this.errorMessage = 'Please enter your search filter';

		this.projects = [];

		document.addEventListener('click', event => {
			if (!this.showed) return;
			if (!this.parentNode.contains(event.target)) {
				this.parentNode.classList.remove('focused');
				this.hide();
			} else {
				this.parentNode.querySelector('input').focus();
			}
		});

	},
	methods: {
		collectData() {

			if (!this.parentNode) {
				this.showed = false;
				return;
			}

			this.parentNode.classList.add('focused');

			if (!this.projects || !this.projects.length) {
				this.search();
			}

		},
		handleClick(event) {
			if (event.target && event.target.classList.contains('projects-global-search')) this.hide();
		},
		openProject(project) {

			this.hide();

			if (!Template.SelectedTemplate || Template.SelectedTemplate.id !== project.template_id) Template.selectTemplate(project.template_id);
			if (!Project.SelectedProject || Project.SelectedProject.id !== project.id) Project.selectProject(project.id);

			Broadcast.call("Preview Refresh");
		},
		search() {
			if (!this.searchValue || !this.searchValue.length) {
				this.errorMessage = 'Please enter your search filter';
				return;
			}
			if (this.searchTimeout) clearTimeout(this.searchTimeout);
			this.errorMessage = 'fetching';

			this.searchTimeout = setTimeout(() => {
				Server.sendToSocket({
					GlobalSearch: {
						value: this.searchValue
					}
				});
			}, 350);

		}
	}
}
</script>


<style lang="sass">

.projects-global-search
	display: flex
	position: absolute
	z-index: 2000
	transform: translate(-32px, 7px)
	line-height: 21px
	font-size: 14px
	text-align: left

	>.card
		width: 350px
		margin: auto
		display: flex
		height: 400px
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.8)
		overflow: hidden
		transition: height 0.5s
		will-change: height
		border-radius: 0.5rem

		>.card-body
			display: flex
			flex-direction: column
			overflow: hidden
			height: 100%
			padding: 5px

		.results
			overflow: hidden auto
			margin-top: 10px
			display: flex
			flex-direction: column
			height: 100%

			>.result
				display: flex
				flex-direction: row
				gap: 20px
				cursor: pointer
				border-radius: 10px
				margin-right: 5px;

				//&:nth-child(odd)
					background-color: #00000030

				&:hover
					background-color: #2f363c

				>.left-part
					display: flex
					align-items: center
					justify-content: center
					min-width: 40px
					max-width: 40px

				>.right-part
					display: flex
					flex-direction: column
					justify-content: space-between
					padding: 3px 0

			.project-icon
				width: 50px
				height: 50px
				background: 50%/100% no-repeat
				border-radius: 10px

			&::-webkit-scrollbar
				width: 10px

			&::-webkit-scrollbar-thumb
				background: #24282c
				border-radius: 5px


</style>

